import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["href"]

import { ref, onMounted } from 'vue';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { getRecentlySoldItems, type RecentlySoldItem } from '@/js/lib/api/item';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecentSoldItems',
  props: {
    categoryId: {}
  },
  setup(__props: any) {

const props = __props;
const rootEl = ref<HTMLDivElement>();
const items = ref<RecentlySoldItem[]>([]);
const itemImageUrl = (imagePath: string) => dynamicImageUrl(imagePath, 310, 310);
const loadItems = async () => {
  const data = await getRecentlySoldItems({ categoryId: props.categoryId ? Number(props.categoryId) : undefined, limit: 24 });
  items.value.push(...data);
};

onMounted(() => {
  if ('IntersectionObserver' in window) {
    const rootElObserver = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          await loadItems();
          rootElObserver.unobserve(rootEl.value!);
        }
      });
    });
    rootElObserver.observe(rootEl.value!);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    (items.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", {
            class: _normalizeClass(_ctx.$style.title)
          }, "最近購入された作品", 2),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("ul", {
            class: _normalizeClass(_ctx.$style.list)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.itemId
              }, [
                _createElementVNode("a", {
                  href: `/listing/item/${item.itemId}`,
                  title: item.title
                }, [
                  _createElementVNode("img", {
                    src: itemImageUrl(item.imagePath),
                    alt: "",
                    width: "155",
                    height: "155",
                    loading: "lazy"
                  }, null, 8, _hoisted_3)
                ], 8, _hoisted_2),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.name)
                }, [
                  _createElementVNode("a", {
                    href: `/listing/item/${item.itemId}`
                  }, _toDisplayString(item.title), 9, _hoisted_4)
                ], 2),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", null, "¥" + _toDisplayString(item.price.toLocaleString()), 1)
              ]))
            }), 128))
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})